module.exports = __webpack_public_path__ + "img/IMG-20200315-WA0050.85fa118d.jpg";